<div class="info-container">
  <button class="close" mat-dialog-close>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
      <path d="M10.244 0.243989C10.0877 0.087763 9.87579 0 9.65482 0C9.43385 0 9.22193 0.087763 9.06566 0.243989L5.24399 4.06566L1.42232 0.243989C1.26605 0.087763 1.05413 0 0.833155 0C0.612185 0 0.400262 0.087763 0.243989 0.243989C0.087763 0.400262 0 0.612185 0 0.833155C0 1.05413 0.087763 1.26605 0.243989 1.42232L4.06566 5.24399L0.243989 9.06566C0.087763 9.22193 0 9.43385 0 9.65482C0 9.87579 0.087763 10.0877 0.243989 10.244C0.400262 10.4002 0.612185 10.488 0.833155 10.488C1.05413 10.488 1.26605 10.4002 1.42232 10.244L5.24399 6.42232L9.06566 10.244C9.22193 10.4002 9.43385 10.488 9.65482 10.488C9.87579 10.488 10.0877 10.4002 10.244 10.244C10.4002 10.0877 10.488 9.87579 10.488 9.65482C10.488 9.43385 10.4002 9.22193 10.244 9.06566L6.42232 5.24399L10.244 1.42232C10.4002 1.26605 10.488 1.05413 10.488 0.833155C10.488 0.612185 10.4002 0.400262 10.244 0.243989Z" fill="black"/>
    </svg>
  </button>

  <div class="content" mat-dialog-content>
    <div *ngIf="isString(data); else componentTemplate">{{ data }}</div>

    <ng-template #componentTemplate>
      <ng-container *ngComponentOutlet="data"></ng-container>
    </ng-template>
  </div>
</div>
